import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {delay} from 'rxjs/operators';

@Injectable()
export class CellSizeObserverService {

    public resize$: Observable<any>;

    public readonly resizeSubject$ = new Subject<void>();

    constructor() {
        this.resize$ = this.resizeSubject$.pipe(

            /**
             * [TT-689] Allow browser to update styles of all nested DOM elements.
             */
            delay(0)
        );
    }

}
